import { USER_TYPES } from 'common/constants';

export const checkIsMapsClient = (userId?: any) =>
  userId === USER_TYPES.mapsClient;
